export default "__VITE_ASSET__DRGO5L7f__"